import { Segment } from '../../components/cohort/HowDoI/HowDoI';

export const MaxReturnsContent: Segment = {
  header: 'Max my returns',
  imageUrl: '/next-assets/images/cohort/athena-maxreturns-superpower.svg',
  imageAlt: "ATHENA'S MAX RETURNS SUPERPOWERS",
  gridContent: [
    {
      title: 'We save, not sting',
      description:
        "Investors don't waste hard made returns with our fee-free loan options. We also drop your rate as you pay down your Straight Up or Power Up loan.",
    },
    {
      title: 'The full Investor toolkit',
      description:
        'Fast equity release, top-ups, split loans, multi-offsets, cross-collateralisation and super sharp IO rates.',
    },
    {
      title: 'Dedicated Investor A-team',
      description: 'A dedicated Investor Expert to text, chat and pimp your portfolio.',
    },
  ],
  quote: {
    author: 'Alan & Sharn, Home Loan Wreckers',
    quote: `"We refinanced one of our investment properties, Athena 
      understood our situation compared to other banks...If you are 
      having troubles with the big banks, I would highly recommend 
      giving Athena a go."`,
    isTrustPilot: true,
  },
};

export const InvestorExpertContent: Segment = {
  header: 'Talk to an Investor Expert',
  imageUrl: '/next-assets/images/cohort/athena-investorexpert-superpower.svg',
  imageAlt: "ATHENA'S INVESTOR EXPERT SUPERPOWERS",
  gridContent: [
    {
      title: 'Your dedicated Investor A-team',
      description:
        'With Athena, you get a dedicated Investor Expert who know you, your situation, and really know their stuff.',
    },
    {
      title: 'Fast answers how you want them',
      description: 'Rapid response SMS or online chat with your dedicated team. Phone and email available too.',
    },
    {
      title: 'Loan structuring to max your asset',
      description:
        'Your Investor Expert can help you structure your loan the right way for your strategy to maximise your investment outcomes.',
    },
  ],
  quote: {
    author: 'Samantha, Home Loan Wrecker',
    quote: '“I love that you can get customer support via SMS and I love that they talk like real people.”',
    isTrustPilot: true,
  },
};

export const LoanStructuringContent: Segment = {
  header: 'Structure my loan to win',
  imageUrl: '/next-assets/images/cohort/athena-loanstructuring-superpower.svg',
  imageAlt: "ATHENA'S LOAN STRUCTURING SUPERPOWERS",
  gridContent: [
    {
      title: 'Powerful splits',
      description: 'Improve your tax deductible interest by using split loans to maximise your investor debt.',
    },
    {
      title: 'Offsets for Investors',
      description:
        'Use our offset accounts to suit your tax strategy. Set up single or multiple offsets and bucket your funds where you need them.',
    },
    {
      title: 'Leverage your assets',
      description: 'Cross-collateralise your properties to tap into their equity and grow your portfolio.',
    },
  ],
  quote: {
    author: 'Claudio, Athena Loan Expert',
    quote:
      '“My customer refinanced to Athena so he could use debt recycling to support his investment strategy. By using our split loans and limit transfer feature, he’s structuring his loan to maximise his tax deductions and investment returns.”',
    isTrustPilot: false,
    avatarUrl: '/next-assets/images/cohort/how-do-i-le-2.png',
  },
};
